import React from 'react';
import "./contactus.css";
import Footer from "./Footer.js"
import contactLogo from "./contactus-logo.jpg";

const services = [
  { icon: "🌐", title: "Website & Backend API Development", desc: "End-to-end web solutions with modern frontends and scalable RESTful backend APIs tailored to your business workflows." },
  { icon: "☁️", title: "Cloud Environment Setup", desc: "Design and provision secure, scalable cloud infrastructure on AWS, Microsoft Azure, or Google Cloud Platform." },
  { icon: "🔄", title: "Data Migration", desc: "Seamless migration of your data from legacy systems or on-premises databases to modern cloud-based platforms with zero data loss." },
  { icon: "🚀", title: "Application Modernization", desc: "Transform monolithic applications into microservices architectures using Java, Spring Boot, and Spring Cloud." },
  { icon: "🤖", title: "AI & Machine Learning Solutions", desc: "Leverage BigQuery, Databricks, Snowflake, and the ELK stack to unlock insights and automate intelligent decision-making." },
  { icon: "🔒", title: "Security & Compliance", desc: "Implement industry-standard security practices, data encryption, and compliance frameworks to protect your business assets." },
  { icon: "📊", title: "Data Lake & Analytics", desc: "Build robust data lakes and analytics pipelines to drive data-driven decisions across your organization." },
  { icon: "🛠️", title: "Ongoing Support & Maintenance", desc: "Dedicated post-deployment support, performance monitoring, and continuous improvement to keep your systems running optimally." },
];

export default function ContactUs() {
  return (
    <>
      <div className='c-screen'>
        <div className="c-container">
          <div className="c-left">
            <div className="cimage-wrapper">
              <img src={contactLogo} alt="Contact" className="cimage" />
            </div>
            <h2 className="c-name">Sasuvika Solutions</h2>
            <p className="c-tagline">Delivering excellence through innovation</p>
            <div className="c-info">
              <div className="c-info-item">
                <span className="c-info-icon">📍</span>
                <span>2326 Taunton Road, Oakville, ON, Canada</span>
              </div>
              <div className="c-info-item">
                <span className="c-info-icon">📞</span>
                <span>+1 (905) 464-5346</span>
              </div>
              <div className="c-info-item">
                <span className="c-info-icon">✉️</span>
                <span>sasikumar.natarajan@sasuvika.ca</span>
              </div>
              <div className="c-info-item">
                <span className="c-info-icon">🕐</span>
                <span>Mon – Fri: 9:00 AM – 6:00 PM</span>
              </div>
            </div>
          </div>
          <div className="c-right">
            <div className="c-services">
              <h2 className="c-services-title">Our Services</h2>
              <p className="c-services-subtitle">Comprehensive technology solutions to grow and modernize your business</p>
              <div className="c-services-grid">
                {services.map((s, i) => (
                  <div className="c-service-card" key={i}>
                    <span className="c-service-icon">{s.icon}</span>
                    <div>
                      <h4 className="c-service-title">{s.title}</h4>
                      <p className="c-service-desc">{s.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </>
  );
}
